// Temporary trial accounts. Remove these exceptions when the users receive User.provider_id.
const PROVIDER_TRIAL_CUSTOMER_USER_IDS = new Set([634, 759, 635]);

export function isProviderHighlightedForSequence(point) {
  if (!point || !['pending', 'postergado'].includes(point.status)) return false;

  return point.user_linked_to_provider === true
    || PROVIDER_TRIAL_CUSTOMER_USER_IDS.has(Number(point.user_id));
}
